import React from 'react'
import Container from '../templates/app/Container'
import UpdateMoment from '../templates/updateMoment/UpdateMoment'
import MomentCard from '../templates/momentCard/MomentCard'

export default ({ userId, momentId }) => (
  <Container>
    <UpdateMoment userId={userId} momentId={momentId}>
      {({ moment, onSaveMoment }) => (
        <MomentCard moment={moment} handleSave={onSaveMoment} />
      )}
    </UpdateMoment>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/pages/UpdateMomentPage.js